import { Controller } from "@hotwired/stimulus";

// Disables submit buttons until the targeted email input passes HTML5 constraint validation.
export default class extends Controller {
  static targets = ["email", "button"];

  declare readonly emailTarget: HTMLInputElement;
  declare readonly buttonTargets: HTMLButtonElement[];

  connect() {
    this.syncButtonStates();
    this.emailTarget.addEventListener("input", this.syncButtonStates);
    this.emailTarget.addEventListener("change", this.syncButtonStates);
  }

  disconnect() {
    this.emailTarget.removeEventListener("input", this.syncButtonStates);
    this.emailTarget.removeEventListener("change", this.syncButtonStates);
  }

  private syncButtonStates = () => {
    const enabled = this.emailTarget.checkValidity();

    this.buttonTargets.forEach((button) => {
      button.disabled = !enabled;
    });
  };
}
